export default {
title: "جزئیات فاکتور",
    back: "بازگشت",
    invoiceNumber: "شماره فاکتور",
    userInfo: "اطلاعات کاربر",
    invoiceInfo: "اطلاعات فاکتور",
    addressInfo: "اطلاعات آدرس",
    fullName: "نام کامل",
    mobile: "موبایل",
    school: "مدرسه",
    orderId: "شناسه سفارش",
    shippingMethod: "روش ارسال",
    paymentMethod: "روش پرداخت",
    receiverPhone: "شماره گیرنده",
    city: "شهر",
    postalCode: "کد پستی",
    items: "آیتم‌های فاکتور",
    product: "محصول",
    quantity: "تعداد",
    price: "قیمت",
    discount: "تخفیف",
    tax: "مالیات",
    total: "مجموع",
    subtotal: "جمع جزء",
    totalDiscount: "مجموع تخفیف",
    shippingCost: "هزینه ارسال",
    totalPrice: "مبلغ نهایی",
     address: "آدرس",            // اضافه شد
    addressDetails: "جزئیات",    // اضافه شد
};
